import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { IncidentQuantumDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-incident-quantum',
  templateUrl: './incident-quantum.component.html',
  styleUrls: ['./incident-quantum.component.scss'],
})
export class IncidentQuantumComponent implements OnChanges {
  incidentquantumForm: FormGroup;
  incidentquantumFormArray: FormGroup;
  control = new FormControl();
  @Input() incidentquantums: IncidentQuantumDto[];
  @Input() routeAnimationsElements: any;
  @Output() incidentquantum = new EventEmitter<IncidentQuantumDto[]>();
  @Output() deleteIncidentQuantumEvent = new EventEmitter<any>();

  selectedIncidentQuantum: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createIncidentQuantumForm();
  }

  createIncidentQuantumForm() {
    this.incidentquantumForm = this.fb.group({
      IncidentQuantumName: ['', Validators.required],
      DistributorFactorValue: ['', Validators.required],
      DistributorFactorName: ['', Validators.required],
      id: null,
    });
    this.incidentquantumFormArray = this.fb.group({
      IncidentQuantums: this.fb.array([]),
    });
    this.setIncidentQuantum();
  }

  // method to display incidentquantums
  setIncidentQuantum() {
    const control = this.incidentquantumFormArray.controls
      .IncidentQuantums as FormArray;
    this.incidentquantums.forEach((e) => {
      control.push(
        this.fb.group({
          IncidentQuantumName: e.IncidentQuantumName,
          DistributorFactorValue: e.DistributorFactorValue,
          DistributorFactorName: e.DistributorFactorName,
          id: e.id,
        })
      );
    });
  }

  // method to add IncidentQuantum
  addIncidentQuantum(value: IncidentQuantumDto) {
    const control = this.incidentquantumFormArray.controls
      .IncidentQuantums as FormArray;
    control.insert(
      0,
      this.fb.group({
        IncidentQuantumName: value.IncidentQuantumName,
        DistributorFactorValue: value.DistributorFactorValue,
        DistributorFactorName: value.DistributorFactorName,
        id: null,
      })
    );
  }

  selectIncidentQuantum(value) {}

  // method to delete incidentquantum from arrary list
  deleteIncidentQuantum(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.incidentquantumFormArray.controls
          .IncidentQuantums as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.incidentquantums.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.incidentquantums[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: IncidentQuantumDto) {
    if (this.incidentquantumForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.incidentquantumFormArray
        .get('IncidentQuantums')
        ['controls'][this.selectedIndex].patchValue({
          IncidentQuantumName: formValue.IncidentQuantumName,
        });
    } else {
      this.addIncidentQuantum(formValue);
    }
    this.selectedIndex = null;
    this.incidentquantumForm.reset();
  }

  onEdit(index, value: IncidentQuantumDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.incidentquantumForm.patchValue({
      IncidentQuantumName: value.IncidentQuantumName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.incidentquantumForm.reset();
  }

  onSubmit(formValue: IncidentQuantumDto[]) {
    this.incidentquantum.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteIncidentQuantumEvent.emit(this.filteredDelete);
    }
  }
}
